export default "__VITE_ASSET__Bh$Whc5T__"